export const Routes = {
  home: {
    path: "/",
    name: "home"
  },
  loading: {
    path: "/loading",
    name: "loading"
  },
  quiz: {
    path: "/quiz",
    name: "quiz"
  },
  result: {
    path: "/result",
    name: "result"
  },
  register: {
    path: "/register",
    name: "register"
  },
  completion: {
    path: "/completion",
    name: "completion"
  },
  not_found: {
    path: "*",
    name: "404"
  }
};
